resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function InputPin() {
  this.extends = [InputText];
  this.node = null;
  this.id = null;

  // Properties
  this.placeholder = "";
  this.error = "";
  this.maxLength = 4;

  // use jquery plugin mask for non touch devices
  this.mask = {
    format: '9999',
    placeholder: '',
    add: function(value) { return this._addMaskCallback(value); }.bind(this), // fallback mask
    remove: function(value) { return this._removeMaskCallback(value); }.bind(this) // fallback unmask
  };


  this.init = function() {
    // Classes
    this._classes = $.extend(this._classes, {
      pin: 'input-pin',
      pinbox: 'input-pin__pinbox',
      box: 'input-pin__box'
    });

    this._$pinbox = $('<div></div>').addClass(this._classes.pinbox);
    this._$box = [
      $('<span></span>').addClass(this._classes.box),
      $('<span></span>').addClass(this._classes.box),
      $('<span></span>').addClass(this._classes.box),
      $('<span></span>').addClass(this._classes.box),
    ];

    // add boxes to pinbox
    this._$pinbox.append(this._$box[0], this._$box[1], this._$box[2], this._$box[3]);
    this.containerDiv.append(this._$pinbox);

    // Setup
    this._super();
    this.containerDiv.addClass(this._classes.pin);
  };

  this.initAllReady = function() {};

  this.destroy = function() {
    this._super();
  };


  this._addMaskCallback = function(value) {
    return String(value).replace(/\D/g, '').substr(0, 4);
  };

  this._removeMaskCallback = function(value) {
    return value;
  };
}
